export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активація електронного чека"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок зарахування"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Серія"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код активації"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевірити"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активувати"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активувати електронний чек"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сума"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активний"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активований"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасований"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активується"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повернення"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В обробці"])}
  }
}